import Link from "next/link";
import { useRouter } from "next/router";
import { signOut, useSession } from "next-auth/react";
import LetterImage from "../ui/LetterImageGenerator";

const links = [
  { path: "/power-app-transactions", title: "Power App Transactions" },
  {
    path: "/challenged-transactions",
    title: "Challenged Transactions",
  },
  { path: "/oltpv-topups", title: "OLTPV Topups" },
  { path: "/banks-and-ecg-offices", title: "Banks / ECG Offices" },
];

const Navbar = () => {
  const router = useRouter();
  const { data: session } = useSession();

  return (
    <nav
      className="navbar navbar-expand-lg navbar-main px-2 position-fixed w-100 z-index-1"
      style={{
        top: 0,
      }}
    >
      <div className="container-fluid">
        <div className="navbar-brand cursor">
          <Link href="/">
            <span>
              <img width={28} height={28} src="/logo.png" alt="logo" />
              Electricity Company of Ghana
            </span>
          </Link>
        </div>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon">
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
            >
              <title>drawer</title>
              <path d="M0.503 1.993c0.228-0.077 0.491-0.122 0.764-0.122 0.089 0 0.177 0.005 0.263 0.014l-0.011-0.001h29.79c0.021-0.001 0.045-0.002 0.069-0.002 0.335 0 0.636 0.146 0.843 0.377l0.001 0.001c0.104 0.156 0.167 0.347 0.167 0.553 0 0.055-0.004 0.109-0.013 0.162l0.001-0.006q0 1.389 0 2.78c0.008 0.047 0.012 0.101 0.012 0.156 0 0.194-0.055 0.374-0.15 0.527l0.002-0.004c-0.208 0.233-0.509 0.38-0.845 0.38-0.030 0-0.060-0.001-0.089-0.003l0.004 0h-29.792c-0.076 0.008-0.164 0.012-0.253 0.012-0.267 0-0.526-0.040-0.768-0.115l0.018 0.005c-0.257-0.096-0.45-0.31-0.515-0.574l-0.001-0.006v-3.533c0.059-0.275 0.248-0.496 0.497-0.6l0.006-0.002z" />
              <path d="M0.218 14.035c0.124-0.136 0.277-0.094 0.416-0.1h12.472c0.243-0.026 0.45 0.365 0.442 0.781 0 1.048 0 2.097 0 3.145 0.004 0.043 0.006 0.094 0.006 0.144 0 0.205-0.037 0.401-0.104 0.582l0.004-0.012c-0.049 0.167-0.2 0.287-0.38 0.287-0.009 0-0.018-0-0.028-0.001l0.001 0q-6.313 0-12.629 0c-0.215 0-0.399-0.307-0.424-0.674v-3.541c0.005-0.234 0.088-0.447 0.224-0.616l-0.002 0.002z" />
              <path d="M0 26.692c0.114-0.415 0.487-0.715 0.931-0.715 0.027 0 0.055 0.001 0.081 0.003l-0.004-0q15.151 0 30.306 0c0.019-0.001 0.042-0.002 0.064-0.002 0.316 0 0.603 0.129 0.809 0.337l0 0c0.118 0.132 0.19 0.308 0.19 0.5 0 0.019-0.001 0.039-0.002 0.058l0-0.003c0 1.096 0 2.193 0 3.288 0.013 0.414-0.499 0.781-1.065 0.753h-30.236c-0.039 0.005-0.083 0.008-0.128 0.008-0.438 0-0.81-0.282-0.944-0.675l-0.002-0.007z" />
            </svg>
          </span>
        </button>
        <div className="collapse navbar-collapse px-2" id="navbarContent">
          <ul className="navbar-nav navbar-main-links text-nowrap">
            {links.map(({ path, title }) => (
              <li
                key={path}
                className={`nav-item ${
                  router.pathname.includes(path.split("?")[0]) && "active"
                }`}
              >
                <Link className="nav-link" href={path}>
                  {title}
                </Link>
              </li>
            ))}
          </ul>
          <ul className="navbar-nav mr-auto nav-profile-and-apps">
            <li className="nav-item dropdown navbar-profile-dropdown">
              <a
                className="nav-link dropdown-toggle pointer"
                href="#"
                id="navbarProfileDropdown"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                <button
                  className="btn align-items-center d-none d-lg-flex"
                  type="button"
                >
                  <LetterImage name={session?.user?.name ?? "User"} />

                  <span className="d-none mx-2 d-md-block text-capitalize">
                    {session?.user?.name}
                  </span>
                </button>
                <span className="d-block d-lg-none">Account</span>
              </a>
              <div
                className="dropdown-menu dropdown-menu-right"
                aria-labelledby="navbarProfileDropdown"
              >
                <div className="dropdown-header">
                  <h5 className="text-truncate">
                    <span className="text-dark">{session?.user?.name}</span>
                    <small>
                      <span className="text-muted">{session?.user?.email}</span>
                    </small>
                  </h5>
                </div>
                <span
                  className="pointer"
                  onPointerDown={() => {
                    const origin = window.location.origin;
                    signOut({
                      callbackUrl: `${origin}/?callbackUrl=${encodeURIComponent(
                        new URL(`${origin}${router.asPath}`).href
                      )}`,
                    });
                  }}
                >
                  <span className="cursor dropdown-item"> Logout </span>
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
